/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeeWeeklyShiftsTotal } from './EmployeeWeeklyShiftsTotal';
import {
    EmployeeWeeklyShiftsTotalFromJSON,
    EmployeeWeeklyShiftsTotalFromJSONTyped,
    EmployeeWeeklyShiftsTotalToJSON,
    EmployeeWeeklyShiftsTotalToJSONTyped,
} from './EmployeeWeeklyShiftsTotal';

/**
 * 
 * @export
 * @interface ShowEmployeeWeeklyShiftsTotalResponse
 */
export interface ShowEmployeeWeeklyShiftsTotalResponse {
    /**
     * 
     * @type {EmployeeWeeklyShiftsTotal}
     * @memberof ShowEmployeeWeeklyShiftsTotalResponse
     */
    data: EmployeeWeeklyShiftsTotal;
}

/**
 * Check if a given object implements the ShowEmployeeWeeklyShiftsTotalResponse interface.
 */
export function instanceOfShowEmployeeWeeklyShiftsTotalResponse(value: object): value is ShowEmployeeWeeklyShiftsTotalResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowEmployeeWeeklyShiftsTotalResponseFromJSON(json: any): ShowEmployeeWeeklyShiftsTotalResponse {
    return ShowEmployeeWeeklyShiftsTotalResponseFromJSONTyped(json, false);
}

export function ShowEmployeeWeeklyShiftsTotalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowEmployeeWeeklyShiftsTotalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeWeeklyShiftsTotalFromJSON(json['data']),
    };
}

  export function ShowEmployeeWeeklyShiftsTotalResponseToJSON(json: any): ShowEmployeeWeeklyShiftsTotalResponse {
      return ShowEmployeeWeeklyShiftsTotalResponseToJSONTyped(json, false);
  }

  export function ShowEmployeeWeeklyShiftsTotalResponseToJSONTyped(value?: ShowEmployeeWeeklyShiftsTotalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeWeeklyShiftsTotalToJSON(value['data']),
    };
}

